import React, { useCallback, useMemo } from 'react';
import ChaserStyledSelect from '../../../../../../components/ChaserStyledSelect';
import MappingTableRow from '../../TableRow';
import { MappingTypeSimpleBase } from '../Simple';
import { useReadOnly } from '../../readOnlyContext';

// @see CSVMappingFieldValueMoney field in chaser-models/src/models/Organisation.ts
const AVAILABLE_DECIMAL_SEPARATORS = [
  { value: 'DEFAULT', label: 'Default' },
  { value: 'NONE', label: 'None (subunit)' },
  { value: 'COMMA', label: ', (comma)' },
  { value: 'DOT', label: '. (dot)' },
];

export const getConsumedColumns = value => {
  return {
    [value?.columnId]: true,
  };
};

export const MappingTypeMoneyDecimalSeparatorSelect = ({
  value,
  onChange,
  containerStyles,
  hideDefault,
  name,
}) => {
  const decimalSeparators = useMemo(() => {
    if (hideDefault) {
      return AVAILABLE_DECIMAL_SEPARATORS.filter(({ value: v }) => v !== 'DEFAULT');
    }
    return AVAILABLE_DECIMAL_SEPARATORS;
  }, [hideDefault]);

  const selectedDecimalSeparator = useMemo(
    () => decimalSeparators.find(({ value: v }) => v === (value || 'DEFAULT')),
    [value, decimalSeparators],
  );

  const handleOnChange = useCallback(
    value => {
      onChange({
        target: {
          name,
          value: value.value,
        },
      });
    },
    [onChange, name],
  );

  const readOnly = useReadOnly();

  return (
    <ChaserStyledSelect
      value={selectedDecimalSeparator}
      onChange={handleOnChange}
      options={decimalSeparators}
      containerStyles={containerStyles}
      name={name}
      isDisabled={readOnly}
    />
  );
};

const MappingTypeMoney = ({ field, value, availableColumns, onChange }) => {
  const handleOnChange = useCallback(
    patch => {
      onChange(patch ? { decimalSeparator: 'DEFAULT', ...value, ...patch } : null);
    },
    [onChange, value],
  );

  return (
    <>
      <MappingTableRow field={field}>
        <MappingTypeSimpleBase
          value={value}
          availableColumns={availableColumns}
          onChange={handleOnChange}
          required={field.required}
        />
      </MappingTableRow>

      {value?.columnId && (
        <MappingTableRow
          field={{
            name: 'Decimal separator',
          }}
          isNested
        >
          <MappingTypeMoneyDecimalSeparatorSelect
            value={value?.decimalSeparator}
            onChange={({ target: { value: v } }) => handleOnChange({ decimalSeparator: v })}
          />
        </MappingTableRow>
      )}
    </>
  );
};

export const Component = MappingTypeMoney;
